var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParallelStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 10.1699C22.9609 11.5599 24.3409 13.7699 24.6209 16.3199",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49023 16.3707C7.75023 13.8307 9.11023 11.6207 11.0902 10.2207",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1895 24.9395C13.3495 25.5295 14.6695 25.8595 16.0595 25.8595C17.3995 25.8595 18.6595 25.5595 19.7895 25.0095",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0593 11.7006C17.5946 11.7006 18.8393 10.456 18.8393 8.92062C18.8393 7.38527 17.5946 6.14062 16.0593 6.14062C14.5239 6.14062 13.2793 7.38527 13.2793 8.92062C13.2793 10.456 14.5239 11.7006 16.0593 11.7006Z",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83078 23.9194C10.3661 23.9194 11.6108 22.6747 11.6108 21.1394C11.6108 19.604 10.3661 18.3594 8.83078 18.3594C7.29543 18.3594 6.05078 19.604 6.05078 21.1394C6.05078 22.6747 7.29543 23.9194 8.83078 23.9194Z",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1706 23.9194C24.706 23.9194 25.9506 22.6747 25.9506 21.1394C25.9506 19.604 24.706 18.3594 23.1706 18.3594C21.6353 18.3594 20.3906 19.604 20.3906 21.1394C20.3906 22.6747 21.6353 23.9194 23.1706 23.9194Z",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallelStep);
export default __webpack_public_path__ + "static/media/parallel-step.71bae27f440a2672e64a2ffe353119b6.svg";
export { ForwardRef as ReactComponent };